import { Injectable, Injector } from '@angular/core';
import { FiAuthenticateSharedService } from '@fi-shared/fi-auth-shared/fi-authenticate-shared.service';
import { windowOpenCentered } from '@fi-shared/fi-shared-services/extensions.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiNewsFeedSharedService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared.service';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { IBackendErrorContentDetails } from '@fi-shared/fi-backend/fi-backend.service';
import { ILoginData } from '@fi-shared/fi-auth-shared/fi-auth-shared';

@Injectable()
export class FiAuthenticateService extends FiAuthenticateSharedService {
    constructor(
        private statisticService: StatisticService,
        private userDataService: FiUserDataService,
        private customerDataService: FiCustomerDataService,
        injector: Injector,
        private fiStateService: FiStateService,
        private newsFeedSharedService: FiNewsFeedSharedService,
        private sessionService: SessionService,
    ) {
        super(injector);
    }

    logout() {
        this.statisticService.stopStatisticsGathering();

        if (this.customerDataService.isADLogin()) {
            const logoutUrl = `ADIntegration/SignOut?token=${encodeURIComponent(this.userDataService.getToken())}`;
            const newWindow = windowOpenCentered(this.fiBackend.getRequestUrl(logoutUrl), 300, 400);
            if (window.focus) {
                newWindow.focus();
            }
        }

        let promisesPool: Promise<void>[] = [];
        promisesPool.push(this.statisticService.flushStatisticToBackend());
        if (this.fiStateService.current.name === FiStateNames.Home._name) {
            promisesPool.push(this.newsFeedSharedService.markAllNewsFeedsAsSeen());
        }

        Promise.all(promisesPool).finally(() => {
            this.fiBackend
                .fetchDataPost('core/authenticate/logout')
                .then((data) => {
                    this.sessionService.resetSession();
                })
                .finally(() => {
                    this.fiStateService.go(FiStateNames.Login.Auth);
                    //window.location.href = '/';
                });
        });
    }

    onUserLicenseAgreementMustAccept(data: IBackendErrorContentDetails, loginData: ILoginData) {
        this.appTextService.loadApplicationLanguageLabels(data.UserPreferredContentLanguageId, true).then(() => {
            this.fiStateService.go(FiStateNames.Login.LicenceAgreement, {
                UserPreferredContentLanguageId: data.UserPreferredContentLanguageId,
                DefaultContentLanguageId: data.DefaultContentLanguageId,
                loginData: loginData,
                agreementNotAcceptedResponse: data,
            });
        });
    }
    onUserConfidentialAgreementMustAccept(data: IBackendErrorContentDetails, loginData: ILoginData) {
        this.appTextService.loadApplicationLanguageLabels(data.UserPreferredContentLanguageId, true).then(() => {
            this.fiStateService.go(FiStateNames.Login.ConfidentialAgreement, {
                UserPreferredContentLanguageId: data.UserPreferredContentLanguageId,
                DefaultContentLanguageId: data.DefaultContentLanguageId,
                loginData: loginData,
                agreementNotAcceptedResponse: data,
            });
        });
    }
}
